import get from 'lodash.get';

import { countries } from '../constants/countries';
import { selectIsFeatureFlagExplicitlyEnabled } from '../modules/featureFlags/featureFlagSelectors';
import { FeatureFlagKeys } from '../modules/featureFlags/featureFlagTypes';
import type { RootState } from '../store';

export const GIFT_AID_AMOUNT_COLUMN = 'giftAidAmount';

export interface GiftAidAccess {
  isUkCharityEnabled: boolean;
  isSystemAdmin: boolean;
  organizationCountry?: string | null;
}

const isGbCountry = (country?: string | null) =>
  !!country &&
  countries[country.toUpperCase() as keyof typeof countries] === countries.GB;

// Gift Aid only exists for United Kingdom charities. System admins work
// across every organisation, UK charities included, so they see it whenever
// the UK charity flag is on.
export const canSeeGiftAid = ({
  isUkCharityEnabled,
  isSystemAdmin,
  organizationCountry
}: GiftAidAccess) =>
  isUkCharityEnabled && (isSystemAdmin || isGbCountry(organizationCountry));

export const selectCanSeeGiftAid = (state: RootState): boolean =>
  canSeeGiftAid({
    isUkCharityEnabled: selectIsFeatureFlagExplicitlyEnabled(
      state,
      FeatureFlagKeys.UkCharity
    ),
    isSystemAdmin: !!get(state, 'session.isSystemAdmin'),
    organizationCountry: get(state, 'session.organization.country')
  });

// For a grid's hideColumn prop: drops the Gift Aid total column, from the grid
// and from its column picker, for anyone who cannot see Gift Aid.
export const isGiftAidColumnHidden = (
  column: { path?: string },
  canSee: boolean
) => !canSee && column.path === GIFT_AID_AMOUNT_COLUMN;
